import styles from './copy-catalog-dialog.module.scss';
import { useCourseGetRequestHook } from '../../../requestUtils';
import BaseCatalogDialog from '../../../base-catalog-dialog/base-catalog-dialog';
import { ICatalogItem } from '../../../_models/catalog-item';
import { useTranslation } from 'react-i18next';

/* eslint-disable-next-line */
export interface CopyCatalogDialogProps {
  onClose: () => void,
  open: boolean,
  refreshData: () => void,
  catalogId: string
}

export function CopyCatalogDialog(props: CopyCatalogDialogProps) {
  const { t } = useTranslation();
  const { data: catalogItem }: { data: ICatalogItem } = useCourseGetRequestHook(`catalog/getItem/${props.catalogId}`, undefined);

  if (!catalogItem) return null;
  catalogItem.id = undefined;
  catalogItem.courseName = catalogItem.courseName + ` ${(t("standard.copy"))}`;
  catalogItem.link = catalogItem.link + ` ${(t("standard.copy"))}`;

  return catalogItem && <BaseCatalogDialog
    onClose={props.onClose}
    open={props.open}
    refreshData={props.refreshData}
    catalogItem={catalogItem}
    handleOkText={t("standard.addCourse")}
    headerText={`${t("standard.newCourse")} <small style="color: #666;">(${(t("standard.copy"))})</small>`}
  />
}

export default CopyCatalogDialog;
